// src/i18n/index.js
//
// Arabic-only configuration. All UI strings live in ar.json.
//
// Usage in a component:
//   import { useTranslation } from 'react-i18next';
//   const { t } = useTranslation();
//   <Typography>{t('auth.signIn')}</Typography>

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ar from '../locales/ar.json';

export const SUPPORTED_LOCALES = ['ar'];
export const RTL_LOCALES = ['ar', 'ur', 'he', 'fa'];

const defaultLocale =
  (typeof window !== 'undefined' && localStorage.getItem('locale')) ||
  process.env.REACT_APP_DEFAULT_LOCALE ||
  'ar';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
    },
    lng: 'ar',
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

/**
 * Switch locale at runtime and persist the preference.
 * Also flips the <html dir> attribute when crossing RTL/LTR boundaries.
 */
export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  i18n.changeLanguage(locale);
  if (typeof window !== 'undefined') {
    localStorage.setItem('locale', locale);
    const dir = RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', locale);
  }
}

// Initial dir/lang setup (first load)
if (typeof window !== 'undefined') {
  const dir = RTL_LOCALES.includes(defaultLocale) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', defaultLocale);
}

export default i18n;
